/**
 * Global Cart Service
 * Holds the current state of the cart
 * handles updating quantity and removing items
 **/

import { ajax } from "../utils";
import eventBus from "./event-bus";

const  CartService  = function() {
  let $this = {};

  $this.currentProduct = false;
  $this.productAdded = false;

  $this.init = function () {
    $this.getCart();
    eventBus.on(eventBus.types.AddingToCart, $this.AddingToCart)
    eventBus.on(eventBus.types.AddedToCart, $this.addedToCart)
  }
  $this.AddingToCart = function ($data) {
    $this.currentProduct = $data.detail;
  }

  $this.addedToCart = function ($data) {
    $this.productAdded = $data;
    $this.getCart();
  }

  $this.getCart = function () {
    ajax('GET', '/cart.json')
      .then(res => {
        res = JSON.parse(res);
        res = JSON.parse(res.response);
        $this.cart = res
        eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
      })
  }

  $this.removeItem = function (key) {
    const $promise = new Promise(function (resolve, reject) {
      ajax('POST', '/cart/change.js', { quantity: 0, id: key })
        .then(
          function (res) {
            let jsonResponse = JSON.parse(res);
            let jsonData = JSON.parse(jsonResponse.response);

            $this.cart = jsonData;
            resolve({ cart: $this.cart, success: true })
            eventBus.dispatch(eventBus.RemovedFromCart, { cart: $this.cart, key: key });
            eventBus.dispatch(eventBus.types.CartUpdated, $this.cart)
          }
        )
    });
    return $promise;
  }

  $this.updateQuantity = function (key, value ) {
    const $promise = new Promise(function (resolve, reject) {
      const data = { quantity: value, id: key };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(response => {
        response.json().then(json => {
          $this.cart = json
          resolve({ cart: $this.cart, success: true })
          eventBus.dispatch(eventBus.types.CartUpdated, $this.cart)
        })
      })
      .catch((error) => {
        alert('There was an error updating the quantity ');
        reject();
      });
    });
    return $promise;
  }

		$this.updateQuantity__update = function( updates ){

      const $promise = new Promise(function (resolve, reject) {
        const data = { updates : updates };
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
        .then(response => {
          response.json().then(json => {
            $this.cart = json
            resolve({ cart: $this.cart, success: true })
            eventBus.dispatch(eventBus.types.CartUpdated, $this.cart)
          })
        })
        .catch((error) => {
          alert('There was an error updating the quantity ');
          reject();
        });
      });
      return $promise;
		}		

  return $this;
}

export default CartService
